/* Pega LP sticky CTA: shows once the visitor scrolls past the first fold,
   hides while any buy box (.pega-lp-offer) is in the viewport. */
(function () {
  var state = { pastFold: false, visibleOffers: 0, ticking: false, observer: null };

  function init() {
    var bar = document.querySelector('[data-pega-lp-sticky]');
    if (!bar) return;
    var offers = document.querySelectorAll('.pega-lp-offer');

    function update() {
      var show = state.pastFold && state.visibleOffers === 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    function onScroll() {
      if (state.ticking) return;
      state.ticking = true;
      window.requestAnimationFrame(function () {
        state.pastFold = window.scrollY >= window.innerHeight * 0.9;
        state.ticking = false;
        update();
      });
    }

    if (state.observer) state.observer.disconnect();
    state.visibleOffers = 0;
    if (offers.length && 'IntersectionObserver' in window) {
      var seen = new Map();
      state.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
        var n = 0;
        seen.forEach(function (v) { if (v) n += 1; });
        state.visibleOffers = n;
        update();
      }, { threshold: 0 });
      offers.forEach(function (el) { state.observer.observe(el); });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  /* Popup suppression (header setting "Hide the site promo popup on this page").
     Klaviyo's modal locks body scroll, so hiding it with CSS alone would freeze the
     page; instead we click its own close button as soon as it mounts, which lets
     Klaviyo unlock scroll and record the dismissal. */
  function suppressPopups() {
    if (!document.querySelector('[data-pega-lp-hide-popups]')) return;
    var closed = 0;
    function tryClose() {
      var modal = document.querySelector('[data-kl-scroll-locking-modal]');
      if (!modal) return false;
      var btn = modal.querySelector('button[aria-label*="lose"], [role="button"][aria-label*="lose"]');
      if (btn) { btn.click(); closed += 1; return true; }
      return false;
    }
    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(function () { tryClose(); });
    mo.observe(document.body, { childList: true, subtree: true });
    tryClose();
    setTimeout(function () { mo.disconnect(); }, 120000);
  }

  function boot() { init(); suppressPopups(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', init);
})();
